import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import DynamicForm from '../../components/DynamicForm';

export default function ClientNew() {
    const [schema, setSchema] = useState(null);
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        api.get('/forms/schemas/active').then(r => setSchema(r.data));
    }, []);

    const handleSubmit = async (data, files) => {
        setBusy(true);
        try {
            const fd = new FormData();
            fd.append('schemaSlug', schema.slug);
            fd.append('data', JSON.stringify(data));
            for (const [key, file] of Object.entries(files || {})) {
                if (file) fd.append(key, file);
            }
            await api.post('/forms/submissions', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            toast.success('Submitted — admin will review');
            nav('/sales/clients');
        } catch { /* toasted */ }
        finally { setBusy(false); }
    };

    if (!schema) return null;

    return (
        <div className="space-y-4">
            <div>
                <h1 className="text-2xl font-extrabold">{schema.name}</h1>
                {schema.description && <p className="text-sm text-ink-500">{schema.description}</p>}
            </div>
            <DynamicForm schema={schema} onSubmit={handleSubmit} busy={busy} />
        </div>
    );
}
